/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import {HISTORY, RUNTIME, Solution} from '@exc/core/src/models/Solution';

export const platformCommon = {
  appRoot: 'experiencePlatformUI',
  distributionList: [`Grp-platform-ui@adobe.com`],
  parent: 'AEP',
  runtime: RUNTIME.CDN,
  sandbox: {
    history: HISTORY.HISTORY,
    sources:
      {
        dev: 'https://localhost.dev.cloud.adobe.io',
        dev2: 'https://localhost.corp.adobe.com',
        qa: 'https://platform-int.adobe.com',
        stage: 'https://platform-stage.adobe.com',
        prod: 'https://platform.adobe.com'
      },
    pageTimeout: 40000
  },
  serviceCode: 'acp',
  sideNav: {
    workHubId: 'AEP',
    workHubFeatureFlag: 'aep-work-hub-enabled'
  },
  urlContext: {key: 'sandbox'}
};

const experiencePlatform: Solution = {
  ...platformCommon,
  appId: 'experiencePlatformUI',
  unifiedSearch: {
    enabled: true
  },
  name: 'platform',
  path: '/platform',
  dashboard: true,
  analytics: {code: 'aep'},
  gainsight: {productKey: 'AP-GLVNMB5BLV8T-2'},
  access: {code: ['acp']},
  experienceLeagueKey: 'Experience Platform'
};

export default experiencePlatform;
